(function($){
    'use strict';
    
}(jQuery));